import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { PayBenchmarkingOutput } from 'libs/end-to-end/src/pay-benchmarking';

export const PayBenchmarkingCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'payBenchmarking',
  isDataQueuingAllowed: true,
  outputFileName: 'pay_benchmarking_output.json',
  outputSchema: PayBenchmarkingOutput,
  resolveFocusArea: () => 'Compensation',
  resolveFilters: () => null,
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  complexityParams: {
    aValue: 0.643,
    multiplier: 0.01495,
  },
  eventProperties: (request) => {
    if (request.customVizId !== 'payBenchmarking') {
      throw new Error('Invalid custom viz ID');
    }
    return {
      'Custom Viz Type': request.customVizId,
      Filters: [
        {
          columnHeaderValue: 'Benchmark',
          values: request.inputs.dropdowns.benchmark,
        },
        {
          columnHeaderValue: 'Location',
          values: request.inputs.dropdowns.location,
        },
        {
          columnHeaderValue: 'Compensation Unit',
          values: request.inputs.dropdowns.compensation_unit,
        },
        {
          columnHeaderValue: 'Currency',
          values: request.inputs.dropdowns.currency,
        },
        {
          columnHeaderValue: 'Department',
          values: request.inputs.dropdowns.department,
        },
        {
          columnHeaderValue: 'Education',
          values: request.inputs.dropdowns.education,
        },
        {
          columnHeaderValue: 'Experience',
          values: request.inputs.dropdowns.experience,
        },
        {
          columnHeaderValue: 'Job Level',
          values: request.inputs.dropdowns.job_level,
        },
        {
          columnHeaderValue: 'Job Title',
          values: request.inputs.dropdowns.job_title,
        },
      ],
      'Selected Dimensions': [],
      'Selected Metrics': [],
      'Selected Focus Areas': [],
    };
  },
  getUrlPath: () => 'copilot/pay-benchmarking',
};
